import { TaskList } from "@/app/Tasks/Components/TaskList";
import {
  QueryTasksWhereColumn,
  SqlOperator,
  TaskStatus,
  TaskType,
} from "@/gql/graphql";

export function ProDriverTasksScreen() {
  return (
    <TaskList
      id="pro-driver-receipt-approval-tasks"
      queryVariables={{
        status: [TaskStatus.Pending, TaskStatus.Overdue],
        where: {
          AND: [
            {
              column: QueryTasksWhereColumn.Type,
              operator: SqlOperator.In,
              value: [TaskType.ReviewDriverReceipts],
            },
          ],
        },
      }}
    />
  );
}
